import React from "react";
import Joi from "joi-browser";
// import Joi from "joi";

import Form from "./common/form";
import Input from "./common/input";
import RefreshIcon from "@material-ui/icons/Refresh";

import { getLoginDetails, login } from "./../services/authService";
import "./../designStyles/LoginForm.css";
import { showErrorToast } from "./utils/toastMessage";
import { withTranslation } from "react-i18next";

class LoginForm extends Form {
  state = {
    data: { email: "", password: "", captchaInput: "" },
    errors: {},
    userUuid: "",
    userDetails: "",
    captchaCode: "",
  };

  schema = {
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .label("Email ID"),
    password: Joi.string().min(5).required().label("Password"),
    captchaInput: Joi.string().required().label("Captcha"),
  };

  generateCaptcha = () => {
    const captchaCode = Math.floor(100000 + Math.random() * 900000).toString();
    this.setState((prevState) => ({
      captchaCode,
      data: { ...prevState.data, captchaInput: "" },
    }));
  };

  validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);
    const errors = {};

    if (error) {
      for (let item of error.details) {
        errors[item.path[0]] = item.message;
      }
    }

    const { data, captchaCode } = this.state;
    if (data.captchaInput !== captchaCode) {
      errors.captchaInput = "Captcha code does not match.";
    }

    return Object.keys(errors).length === 0 ? null : errors;
  };

  doSubmit = async () => {
    const { t } = this.props;

    try {
      const { data } = this.state;
      await login(data.email, data.password);
      window.location = "/allAssessmentTypes";
    } catch (ex) {
      // console.log("Error in login:", ex);
      if (ex.response && ex.response.status === 400) {
        showErrorToast(t(`LogIn.${ex.response.data.message}`));
        this.generateCaptcha();
      }
    }
  };

  async getUsersDetail(userUuid) {
    const userDetails = await getLoginDetails(userUuid);
    this.setState({ userDetails });
    this.setState({ data: { email: userDetails?.email } });
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const userUuid = params.get("userUuid");
    const language = params.get("language");
    this.setState({ userUuid });
    this.getUsersDetail(userUuid);

    let selectedLanguage = "";
    if (language) {
      selectedLanguage = language;
      localStorage.setItem("selectedLanguage", language);
    } else {
      selectedLanguage = localStorage.getItem("selectedLanguage") || "en";
    }
    this.changeLanguage(selectedLanguage);
    this.generateCaptcha();
  }

  changeLanguage(lng) {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        {/* <ToastContainer /> */}
        <section id="login-page" className="login-page">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-sm-6">
                <div className="login-left-main">
                  <img
                    src="images/login-bg-2.jpg"
                    className="img-fluid"
                    alt=""
                  />
                  <div className="login-overlay">
                    <div className="row">
                      <div className="col-sm-12">
                        <h2 className="heading-white">
                          {t("LogIn.Welcome back")}
                        </h2>
                      </div>
                      <div className="col-sm-12">
                        <p>{t("LogIn.True Potential Message")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="right-login">
                  <div className="body-widget">
                    <h2 className="heading-black">
                      <h1>{t("LogIn.Log In")}</h1>
                    </h2>
                    {/* <h2 className="heading-black">Log In</h2> */}
                    <form onSubmit={this.handleSubmit}>
                      {this.state.userUuid
                        ? this.renderInput("email", t("LogIn.Email"), true)
                        : this.renderInput("email", t("LogIn.Email"))}
                      {this.state.userUuid
                        ? this.renderPassword(
                            "password",
                            t("LogIn.Temporary Password*"),
                            "password",
                          )
                        : this.renderPassword(
                            "password",
                            t("LogIn.Password"),
                            "password",
                          )}
                      {/* {this.renderPassword("password", "Password", "password")} */}
                      <div className="form-group">
                        <label htmlFor="captchaInput">{t("Enter Captcha Code")}</label>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div style={{
                            backgroundColor: "#f8f9fa",
                            padding: "8px 16px",
                            fontSize: "20px",
                            fontWeight: "bold",
                            fontStyle: "italic",
                            letterSpacing: "4px",
                            borderRadius: "4px",
                            border: "1px dashed #cbd5e1",
                            userSelect: "none",
                            color: "#334155",
                            height: "38px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "120px"
                          }}>
                            {this.state.captchaCode}
                          </div>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            style={{ 
                              height: "38px",
                              padding: "0 12px", 
                              fontSize: "12px", 
                              border: "1px solid #ccc", 
                              background: "#f8f9fa", 
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                            onClick={this.generateCaptcha}
                            title={t("LogIn.Refresh")}
                          >
                            <RefreshIcon style={{ fontSize: 16, color: "#555" }} />
                          </button>
                          <input
                            type="text"
                            name="captchaInput"
                            id="captchaInput"
                            value={this.state.data.captchaInput}
                            onChange={this.handleChange}
                            className="form-control"
                            placeholder="Type Code"
                            style={{ height: "38px", flex: 1 }}
                            autoComplete="off"
                          />
                        </div>
                        {this.state.errors.captchaInput && (
                          <div className="alert alert-danger" style={{ marginTop: "5px" }}>
                            {this.state.errors.captchaInput}
                          </div>
                        )}
                      </div>
                      {this.renderButton(t("LogIn.Sign In"))}
                    </form>
                    <a href="/reset" style={{ float: "right" }}>
                      {t("LogIn.Forgot Password")}
                    </a>{" "}
                    <br></br>
                    <a href="/updatePass" style={{ float: "right" }}>
                      {" "}
                      {t("LogIn.Update Password")}
                    </a>{" "}
                    <p>
                      {t("LogIn.Don't have an account?")}
                      <a href="/registration"> {t("LogIn.Sign Up")} </a>{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="logo-main">
              <img src="images/logo.png" alt="" />
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default withTranslation()(LoginForm);
